import React from 'preact/compat';
import { ComponentChildren } from 'preact';
import FormRequired from './required';

export default function FormLabel({ htmlFor, required, children }: LabelProps) {
    return (
        <label htmlFor={htmlFor} className='form__label'>
            {children}
            {required && <FormRequired />}
        </label>
    );
}

export type LabelProps = {
    children: ComponentChildren,
    htmlFor: string,
    required?: boolean,
};
